<template>
    <div class="flex-page">
        <a-form class="form" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">

            <a-form-item label="类名">
                {{ info.cate1_name }}
                <span v-if="info.lat_cate1_name">({{ info.lat_cate1_name }})</span>
            </a-form-item>
            <a-form-item label="科名">
                {{ info.cate2_name }}
                <span v-if="info.lat_cate2_name">({{ info.lat_cate2_name }})</span>
            </a-form-item>
            <a-form-item label="名称">
                {{ info.name }}
                <span v-if="info.lat_name">({{ info.lat_name }})</span>
            </a-form-item>
            <a-form-item label="尺寸">
                {{ info.size }}mm
            </a-form-item>
            <a-form-item label="图片">
                <img @click="openPic(info.pic)" style="max-height: 100px;cursor: pointer;" v-if="info.pic"
                    :src="info.pic" alt="">
            </a-form-item>
            <a-form-item label="标本所有人">{{ info.suoyouren }}</a-form-item>
            <a-form-item label="标本上传人">{{ info.shangchuanren }}</a-form-item>
            <a-form-item label="标本产地">{{ info.chandi }}</a-form-item>
            <a-form-item label="尺寸复核人">{{ info.fuheren }}</a-form-item>
            <a-form-item label="见证人">{{ info.jianzhengren }}</a-form-item>
            <a-form-item label="当前状态">
                <a-tag color="orange" v-if="info.status == 0">审核中</a-tag>
                <a-tag color="blue" v-if="info.status == 1">已通过</a-tag>
                <a-tag color="red" v-if="info.status == -1">已拒绝 </a-tag>
                <a-tag color="red" v-if="info.status == -2">已删除 </a-tag>
            </a-form-item>
            <a-form-item label="用户微信">
                <div style="display: flex; align-items: center;">
                    <img class="weixin-headimg-radio" style="width: 40px; border-radius: 50%;margin-right: 5px;"
                        :src="info.headimgurl" alt="">
                    {{ info.nickname }}
                </div>
            </a-form-item>
            <a-form-item label="用户名">
                {{ info.yonghuming }}
            </a-form-item>
            <a-form-item label="用户电话">
                {{ info.tel }}
            </a-form-item>
        </a-form>
        <div class="buttons">
            <a-button v-if="info.status == 0" @click="showShenhe" style="margin-left: 5px" type="primary">
                通过
            </a-button>

            <a-popconfirm v-if="info.status == 0 || info.status == 1" title="确定要拒绝吗"
                @confirm="changeStatus(info.id, -1)" okText="确定" cancelText="取消">
                <a-button style="margin-left: 5px" type="danger">
                    拒绝
                </a-button>
            </a-popconfirm>

            <a-popconfirm title="确定要删除吗" @confirm="changeStatus(info.id, -2)" okText="确定" cancelText="取消">
                <a-button style="margin-left: 5px" type="danger">
                    删除
                </a-button>
            </a-popconfirm>

            <a-button type="primary" @click="toUrl">编辑</a-button>
        </div>
        <Tongguo v-if="shenhe.show" :id="id" @tongguoCallBack="tongguoCallBack" />
    </div>
</template>

<style lang="scss" scoped>
.form {
    padding: 40px;
}

.sec {
    margin: 15px;
}

img {
    max-width: 100%;
}
</style>

<script>
import Tongguo from './component/tongguo.vue'

export default {
    components: { Tongguo },
    data() {
        return {
            formItemLayout: {
                labelCol: {
                    span: 3,
                },
                wrapperCol: {
                    span: 20,
                },
            },
            id: null,
            shenhe: {
                show: false,
            },
            cateList: [],
            info: {},
        };
    },
    async created() {
        this.id = this.$route.query.id;
        this.getDetail()
    },
    methods: {
        async getDetail() {
            const r = await this.$axios.get('/chicun/getLogInfo?id=' + this.id);
            if (r.status == 1) {
                this.info = r.data
            }
        },
        async changeStatus(id, status) {
            const r = await this.$axios.post("/chicun/changeLogStatus", {
                id: id,
                status: status,
            });
            if (r.status == 1) {
                // this.$message.success('操作成功')
                this.getDetail();
            } else {
                this.$message.error('操作失败...')
            }
        },
        showShenhe() {
            this.shenhe.show = true
        },
        cancelTongguo() {
            this.shenhe.show = false
        },
        tongguoCallBack(e) {
            this.cancelTongguo()
            if (e.status == 1) {
                this.getDetail();
            }
        },
        toUrl() {
            this.$router.push('/chicun/logEdit?id=' + this.id)
        },
        openPic(url) {
            window.open(url)
        }
    },
};
</script>